export const ADD_DISCOUNT = "ADD_DISCOUNT";
export const REMOVE_DISCOUNT = "REMOVE_DISCOUNT";
export const ADD_DISCOUNT_AMOUNT = "ADD_DISCOUNT_AMOUNT";
export const SET_DISCOUNT_LOADING = "SET_DISCOUNT_LOADING";
export const SET_DISCOUNT_ERROR = "SET_DISCOUNT_ERROR";
export const CLEAR_DISCOUNT_ERROR = "CLEAR_DISCOUNT_ERROR";
export const clearDiscount = () => ({
  type: "CLEAR_DISCOUNT",
});

export const onAddDiscount = (payload) => {
  return (dispatch) => {
    dispatch({
      type: ADD_DISCOUNT,
      relativeDiscount: payload.relativeDiscount,
      discountCode: payload.discountCode,
    });
  };
};

export const onRemoveDiscount = () => {
  return (dispatch) => {
    dispatch({
      type: REMOVE_DISCOUNT,
    });
  };
};

export const onAddDiscountAmount = (data) => {
  return {
    type: ADD_DISCOUNT_AMOUNT,
    payload: data,
  };
};

export const onSetDiscountLoading = (isLoading) => {
  return {
    type: SET_DISCOUNT_LOADING,
    payload: isLoading,
  };
};

export const onSetDiscountError = (errorMessage) => {
  return {
    type: SET_DISCOUNT_ERROR,
    payload: errorMessage,
  };
};

// Action to clear discount error
export const onClearDiscountError = () => {
  return {
    type: CLEAR_DISCOUNT_ERROR,
  };
};
